<template>
	<div class="apply">
		<!-- 顶部导航 -->
		<div class="nav">
			<van-icon name="arrow-left" color="#fff" size="1.2rem" @click="back" />
			<span>申请售后</span>
			<div></div>
		</div>
		<!-- 申请售后 -->
		<van-panel class="sale">
			<div slot="header" class="van-panel__header">
				<span>订单编号:00000000000000</span>
			</div>
			<div class="content">
				<div class="list">
					<van-card desc="2.8米X3.8米X1.5米  胡桃木色 拷贝" title="格诺瓦  维纳  B款总裁台" thumb="../../assets/bantai(2).png">
						<div slot="price">
							<span>租金</span><span class="active">¥10000</span>
							<span>购买数量</span><span class="active">10</span>
						</div>
					</van-card>
					<van-cell title="申请数量">
						<div slot="default">
							<van-stepper v-model="value" input-width="1rem" button-size="1rem" />
						</div>
					</van-cell>
				</div>
			</div>
		</van-panel>
		<!-- 填写内容 -->
		<van-panel class="container">
			<div slot="header">
				<van-cell title="申请原因">
					<div slot="default" class="container__value">
						<van-radio-group v-model="radio" checked-color="#f1452f">
							<van-radio name="1">维修</van-radio>
							<van-radio name="2">换货</van-radio>
						</van-radio-group>
					</div>
				</van-cell>
			</div>
			<van-cell-group>
				<van-field rows="2" autosize type="textarea" placeholder="请详细描述申请售后服务的原因,最多可以上传9张图片哦~" show-word-limit />
				<van-uploader v-model="fileList" multiple :max-count="4" />
				<div class="tips1">为了帮您更好的解决问题,请务必上传照片凭证</div>
			</van-cell-group>
		</van-panel>
		<!-- 用户信息 -->
		<van-cell-group class="apply_footer">
			<van-cell>
				<div slot="title">
					联系人:&nbsp;&nbsp;黄英
				</div>
			</van-cell>
			<van-cell>
				<div slot="title">
					联系电话:&nbsp;&nbsp;185****2019
				</div>
			</van-cell>
			<van-cell>
				<div slot="title">
					地址:&nbsp;&nbsp;陕西省西安市大兴西区太奥广场六楼兆生家具
				</div>
			</van-cell>
		</van-cell-group>
		<span class="tips2">提交服务订单后,售后专员会与您电话沟通,请保持手机畅通</span>
		<!-- 提交结果 -->
		<div class="footer-bar">
			<button>提交</button>
		</div>
		<!-- 遮罩层 -->
		<van-overlay :show="show" @click="show = false" />
	</div>
</template>

<script>
	export default {
		data() {
			return {
				radio: '1',
				value: 1,
				fileList: [],
				show: false
			}
		}
	}
</script>

<style>
	@import 'apply.css'
</style>



// WEBPACK FOOTER //
// src/components/min/apply.vue